import { Store, select } from '@ngrx/store';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { State } from '@app/store/state/state';
import { AlertResponse, AlertPayload, AlertIdentificators } from '@shared/widgets/entities/alerts';
import {
  createAlertAction,
  deleteAlertAction,
  loadAlertSuccessAction,
  resetWidgetDataAction,
  setActiveAlertsUIAction
} from '@shared/widgets/store/actions/alerts.action';
import { selectUserAlertsEntities } from '@app/store/selectors/user-alerts.selector';
import { ActiveAlertsPipe } from '@user-alerts/pipes/active-alerts.pipe';
import { FlightResultsMobile } from '@app/entities/flight-results';
import { selectPassengerArrangement } from '@shared/base-search-bar/store/selectors/passenger-arrangement.selector';
import { PassengerArrangement } from '@shared/base-search-bar/entities/passenger-arrangement';

@Injectable()
export class UserAlertsFacade {

  constructor(
    private store: Store<State>,
    private activeAlertsPipe: ActiveAlertsPipe
  ) { }

  get alertsEntities$(): Observable<AlertResponse[]> {
    return this.store.pipe(
      select(selectUserAlertsEntities)
    );
  }

  get alertsActiveEntites$(): Observable<AlertResponse[]> {

    return this.store.pipe(
      select(selectUserAlertsEntities),
      map((entites) => {
        return this.activeAlertsPipe.transform(entites);
      })
    );
  }

  get isLoadingAlertList$(): Observable<boolean> {
    return this.store.pipe(
      map((state) => state.isLoadingAlertList)
    );
  }

  private get passengerArrangementsState$(): Observable<PassengerArrangement[]> {
    return this.store.pipe( select(selectPassengerArrangement) );
  } 

  public createAlert(payload: AlertPayload | AlertResponse): void {
    this.store.dispatch(createAlertAction({ payload }));
  }

  public deleteAlert(alert: AlertIdentificators): void {
    this.store.dispatch(deleteAlertAction({ alert }));
  }

  public loadAlertSuccess(data: AlertResponse): void {
    this.store.dispatch(loadAlertSuccessAction({ data }));
  }

  public setActiveAlertsUI(payload: boolean): void {
    this.store.dispatch(setActiveAlertsUIAction({ payload }));
  }

  public resetWidgetData(): void {
    this.store.dispatch(resetWidgetDataAction());
  }

  public alertPricePerAdult$(itinerary: FlightResultsMobile): Observable<number> {
    return this.passengerArrangementsState$.pipe( map(passengerArrangement => 
      itinerary?.AdultsTotalAmount / passengerArrangement[0]?.quantity
    ));
  }

}
